// These are the hexcodes of the Site Colors
export const siteColorsArray = [
    'e4e8eb',
    'd6412f',
    'e6145e',
    '9d1bb2',
    '6734ba',
    '3e4eb8',
    '3773db',
    '00bcd6',
    '008577',
    'ffd000',
    'ff9900',
    '7a5547',
    '737373'
];

// This returns the background hexcodes for the different shades based on the current color
export function greyScaleBoxBackgroundColor(number, baseRed, baseGreen, baseBlue) {
    const baseTenRed = parseInt(baseRed, 16);
    const baseTenGreen = parseInt(baseGreen, 16);
    const baseTenBlue = parseInt(baseBlue, 16);
    switch (number) {
    case 1:
        return '#000000';
    case 2:
        return `rgb(${Math.floor(0.25 * baseTenRed)},${Math.floor(0.25 * baseTenGreen)},${Math.floor(0.25 * baseTenBlue)})`;
    case 3:
        return `rgb(${Math.floor(0.50 * baseTenRed)},${Math.floor(0.50 * baseTenGreen)},${Math.floor(0.50 * baseTenBlue)})`;
    case 4:
        return `rgb(${Math.floor(0.75 * baseTenRed)},${Math.floor(0.75 * baseTenGreen)},${Math.floor(0.75 * baseTenBlue)})`;
    case 5:
        return `rgb(${baseTenRed},${baseTenGreen},${baseTenBlue})`;
    case 6:
        return `rgb(${(Math.floor(0.25 * (255 - baseTenRed)) + baseTenRed)},${(Math.floor(0.25 * (255 - baseTenGreen)) + baseTenGreen)},${(Math.floor(0.25 * (255 - baseTenBlue)) + baseTenBlue)})`;
    case 7:
        return `rgb(${(Math.floor(0.50 * (255 - baseTenRed)) + baseTenRed)},${(Math.floor(0.50 * (255 - baseTenGreen)) + baseTenGreen)},${(Math.floor(0.50 * (255 - baseTenBlue)) + baseTenBlue)})`;
    case 8:
        return `rgb(${(Math.floor(0.75 * (255 - baseTenRed)) + baseTenRed)},${(Math.floor(0.75 * (255 - baseTenGreen)) + baseTenGreen)},${(Math.floor(0.75 * (255 - baseTenBlue)) + baseTenBlue)})`;
    case 9:
        return '#ffffff';
    default:
        return '#444444';
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/theme-selector-helper.js